import MiddleBanner from "../middle-banner/middle-banner.vue";
import Talents from "./talents/talents.vue";
import Workshops from "./workshops/workshops.vue";
import { mediaQuery } from "../../mixins/media-query";
import { gtagMixin } from "../../mixins/gtag-mixin";

export default {
  components: { MiddleBanner, Talents, Workshops },
  props: ["idNav", "servicesData"],
  mixins: [mediaQuery, gtagMixin],
};
